import axios from 'axios';
import store from '@/store';
import WorkCookies from "@/services/cookie_services/WorkCookies";

export default {
  clearEverything() {
    this.clearCookies();
    this.clearAllVuexStores();
    this.clearLocalStorage();
    this.clearSessionStorage();
    this.clearAxiosHeaders();
  },
  /** COOKIES **/
  clearCookies() {
    WorkCookies.removeAuthToken();
    WorkCookies.removeWebsocket();
  },
  /** STORAGE **/
  clearLocalStorage() {
    window.localStorage.clear()
  },

  clearSessionStorage() {
    window.sessionStorage.clear();
  },
  /** AXIOS **/
  clearAxiosHeaders() {
    this.clearAxiosXAuthToken();
    this.clearAxiosActingUser();
  },

  clearAxiosXAuthToken() {
    delete axios.defaults.headers.common['X-AUTH-TOKEN'];
  },

  clearAxiosActingUser() {
    delete axios.defaults.headers.common['ACTING-USER'];
  },
  /** VUEX **/
  clearAllVuexStores() {
    this.clearActingUser();
    this.clearActiveWindows();
    this.clearConfigurations();
    this.clearGlobalSnackbarStore();
    this.clearRoutingHistory();
    this.clearErrorNotificationStore();
    this.clearPresetStore();
    this.clearTableStore();
    this.clearMobileWrapperTasks();
    this.clearGlobalEventListeners();
  },

  clearActingUser() {
    store.dispatch('actingUser/resetState');
  },

  clearActiveWindows() {
    store.dispatch('activeWindows/resetStore');
  },

  clearConfigurations() {
    store.dispatch('configuration/resetStore');
  },

  clearGlobalSnackbarStore() {
    store.dispatch('globalSnackbarStore/resetStore');
  },

  clearRoutingHistory() {
    store.dispatch('routingHistory/resetStore');
  },

  clearErrorNotificationStore() {
    store.dispatch('errorNotificationStore/resetStore');
  },

  clearPresetStore() {
    store.dispatch('tableStore/resetStore');
  },

  clearTableStore() {
    store.dispatch('tableStore/resetStore');
  },

  clearMobileWrapperTasks() {
    store.dispatch('mobileWrapperTasks/removeAllOpenTasks');
  },

  clearGlobalEventListeners() {
    store.dispatch('globalEventListeners/setKeyUpHandlersToDefault');
  },
}
